<template>
  <typeahead :src="src"
             :options="options"
             :input-options="{placeholder}"
             :disabled="disabled"
             v-model="model[attribute]"
             ref="typeahead"
             :display-field="displayField">
    <template v-slot:no-data-found>
      {{$t('Receipts Not Found.')}} <a href="javascript:void(0)" @click="onCreateNewClick">{{$t('Create New')}}</a>
    </template>
  </typeahead>
</template>

<script>
  import Typeahead from "../components/common/Typeahead";
  import i18n from "../../shared/i18n";
  import {SOURCE_RECEIPT_TYPEAHEAD} from "@/modules/constants";
  import {createNamespacedHelpers} from "vuex";

  const {mapActions} = createNamespacedHelpers('receipts');

  export default {
    name: "ReceiptTypeahead",
    components: {Typeahead},
    props: {
      valueField: {
        type: String,
        default: ''
      },
      displayField: {
        type: String,
        default: 'receipt_no'
      },
      model: {
        type: Object,
        required: true
      },
      attribute: {
        type: String,
        required: true
      },
      src: {
        type: String,
        default: '/api/v1/receipts/'
      },
      placeholder: {
        type: String,
        default: i18n.t('Receipt')
      },
      disabled: {
        type: Boolean,
        default: false
      },
      options: {
        type: Object,
        default: () => {
          return {queryParamName: 'receipt_no', data: {expand: 'customer.billing_address'}}
        }
      },
      creationSource: {
        type: String,
        default: SOURCE_RECEIPT_TYPEAHEAD
      }
    },
    methods: {
      ...mapActions(['showModal']),
      onCreateNewClick() {
        this.showModal({
          object: {receipt_no: this.$refs.typeahead.getQuery()},
          source: this.creationSource
        });
      },
      focus(){
        this.$refs.typeahead.focus();
      },
      clear(){
        this.$refs.typeahead.clear();
      }
    }
  }
</script>

<style lang="scss" scoped>

</style>
